"use strict";var __importDefault=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(exports,"__esModule",{value:!0}),exports.StyledOauthButtonSection=void 0;const styled_components_1=__importDefault(require("styled-components"));exports.StyledOauthButtonSection=styled_components_1.default.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;